import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { NgxPendoService } from "ngx-pendo";
import type { Subscription } from "rxjs";
import { environment } from "../../../environments/environment";
import { AccountService } from "../../core";
import type { IPendoInitialize } from "./pendo.model";

@Injectable({ providedIn: "root" })
export class PendoService {
    private readonly http = inject(HttpClient);
    private readonly accountService = inject(AccountService);
    private readonly ngxPendoService = inject(NgxPendoService);

    resourceUrl = environment.apiUrl + "api/pendo";
    subscription: Subscription;
    initialized = false;

    private initializePendo(): void {
        this.http
            .get<IPendoInitialize>(this.resourceUrl)
            .subscribe((pendoInitialize) => {
                this.ngxPendoService.initialize({
                    visitor: {
                        id: pendoInitialize.visitorId,
                        email: pendoInitialize.visitorEmail,
                        createdDate: pendoInitialize.visitorCreatedDate,
                        lastLogin: pendoInitialize.visitorLastLogin,
                        isInternal: pendoInitialize.visitorIsInternal,
                    },
                    account: {
                        id: pendoInitialize.accountId,
                        name: pendoInitialize.accountName,
                        creationDate: pendoInitialize.accountCreationDate,
                        firmPlanTier: pendoInitialize.accountFirmPlanTier,
                        subdomain: pendoInitialize.accountSubdomain,
                        firmUserCount: pendoInitialize.accountFirmUserCount,
                        isBeta: pendoInitialize.accountIsBeta,
                        cancellationDate:
                            pendoInitialize.accountCancellationDate,
                    },
                });
            });
    }

    registerPendo(): void {
        this.subscription = this.accountService.userIdentity.subscribe(
            (user) => {
                if (user && !this.initialized) {
                    this.initialized = true;
                    this.initializePendo();
                } else if (user === null && this.initialized) {
                    this.initialized = false;
                    this.ngxPendoService.teardown();
                }
            },
        );
    }

    unregisterPendo(): void {
        this.subscription?.unsubscribe();
    }
}
